// import Privileges from './Privileges';
import Robot from './RobotSetting';
import Wordbank from './Wordbank';
import SSM from './SSM';
import Statistics from './Statistics';
import TaskEngine from './TaskEngine';
import Status from './Status';
import IntentEngine from './IntentEngine';
import KnowledgeGraphNew from './KnowledgeGraph';
import ChatTools from './ChatTools';
import NER from './NER';
import CustomizedSkill from './CustomizedSkill';

export default {
  Status,
  SSM,
  TaskEngine,
  IntentEngine,
  Wordbank,
  NER,
  KnowledgeGraphNew,
  Statistics,
  Robot,
  ChatTools,
  CustomizedSkill,
};



// WEBPACK FOOTER //
// ./src/modules/index.js